import React, { useRef } from 'react'
import { isEmpty, uniqueId } from 'lodash'
import PropTypes from 'prop-types'
import { useInView } from 'framer-motion'
import { renderColumns } from '../../utils/renderColumns.jsx'

ContentForDesktop.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
}

function ContentForDesktop({ data, loading }) {
  const ref = useRef(null)

  const isInView = useInView(ref, { once: true })

  if (isEmpty(data)) return null

  return (
    <div className="main-container flex flex-col items-center justify-center">
      <h1
        className="heading1 2xl:whitespace-nowrap text-center uppercase leading-none mt-auto mb-auto"
        ref={ref}
      >
        {data?.map((row, index) => {
          const rowKey = uniqueId()

          const column1 = row?.column1
          const column2 = row?.column2
          const columns = [column1, column2]

          const rowDelay = index * 0.5

          return (
            <span
              key={rowKey}
              className={`flex space-x-6 items-end justify-center overflow-hidden mb-[14px]`}
            >
              {renderColumns({ columns, rowDelay, isInView, loading })}
            </span>
          )
        })}
      </h1>
    </div>
  )
}

export default React.memo(ContentForDesktop)
